import axios from "axios";
import { route } from "preact-router";
import config from "../lib/config";
import useUserStore from "../store/userStore";



const baseConfig = {
    baseURL: config.api.url,
    withCredentials: false
}

const instance = axios.create(baseConfig);

instance.interceptors.request.use(
    function (config) {
        const accessToken = useUserStore.getState().accessToken;

        if (accessToken) {
           config.headers.Authorization = `Bearer ${accessToken}` ;
        }

        return config;
    },
    function (error) {
        return Promise.reject(error)
    }
)
instance.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        // 401 = token révoqué (éviction : connexion détectée sur un autre poste)
        // ou expiré. On vide la session locale et on redirige vers le login.
        if (error.response?.status === 401 && useUserStore.getState().accessToken) {
            useUserStore.getState().removeCredentials();
            route("/login?reason=session_closed");
        }

        return Promise.reject(error);
    }
)
export default instance;
